/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React, { Component } from "react";
import "./styles/css/signup.css";
import { Button, Segment, Form, Header, Label, Icon, Image } from "semantic-ui-react";
import { Input, FreeForm, FormRow, Dropdown } from "kx-common-components";
import { Redirect, Link } from "react-router-dom";
import API from "../utility/API";
import { get } from "lodash";
import Logo from "../media/newlogo2.png";
import Ship from "../media/thanks-ship.svg"


class Maintenance extends Component {
  constructor() {
    super();
    this.state = {
      companyName: "",
      email: "",
      contactName: "",
      error: false,
      nextPath: '/'
    };
  }



  render() {

    return (
      <Segment padded="very" className="signup-container">
          <p className="login-header">Maintenance</p>

          <Image style={{ width: '300px' }} src={Ship} />
          <br />
          <p>Some new features are coming your way. Please check back later.</p>
      </Segment>
    );
  }
}

export default Maintenance;
